import handler from "api/handler";

const prefix = "/public/resume";

const methods = {
    create: (data, config = {}) =>
        handler({
          method: 'post',
          url: `${prefix}/create`,
          data,
          ...config,
        }),
    get: (params) =>handler({ method: 'get', url: `${prefix}/all`, params}),
    update: (id, data, config = {}) => handler({method: 'put',url: `${prefix}/update/${id}`,data,...config}),
    delete: (id, config = {}) =>handler({method: 'delete',url: `${prefix}/delete/${id}`,...config}),
};

export default methods;